import React, { useEffect, useState } from "react";
import { Router, Route, Switch } from "react-router-dom";
import queryString from "query-string";
import { getUrls } from "./routes";
import history from "./history";

const Routes = (props) => {
  const [dynamicRoutes, setDynamicRoutes] = useState(false);

  useEffect(() => {
    const transactionId = queryString.parse(window.location.search)?.transaction_id;
   
    if (transactionId) {
      sessionStorage.setItem("appId", transactionId);
    }
    if (!dynamicRoutes) {
      getUrls().then((res) => {
        setDynamicRoutes(res);
      });
    }
  });
  return (
    <Router history={history}>
      <Switch>
        {dynamicRoutes &&
          dynamicRoutes.map((route, index) => {
            const { component: RouteComponent, routes, exact, path } = route;
            return (
              <Route
                exact={exact}
                key={index}
                path={path}
                render={() => <RouteComponent {...props} routes={routes} />}
              />
            );
          })}
      </Switch>
    </Router>
  );
};

export default Routes;
